
import axios from "axios";
import toast from "react-hot-toast";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true
});

let isLoggingOut = false;

api.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status;
    const code = error?.response?.data?.code || error?.response?.code;

    if (
      status === 401 &&
      (code === "TOKEN_EXPIRED" || code === "TOKEN_MISSING")
    ) {
      if (!isLoggingOut) {
        isLoggingOut = true;

        try {
          await axios.post(
            `${process.env.REACT_APP_BASE_URL}/logout`,
            {},
            { withCredentials: true }
          );
        } catch {
          // ignore
        }

        toast.error("Session expired. Please login again.");

        localStorage.clear();
        sessionStorage.clear();

        setTimeout(() => {
          window.location.replace("/login");
        }, 1500);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
